module.exports = "\n<div class=\"newsletter__subscribe newsletter__subscribe_error\">\n  <header class=\"newsletter__header\">{{ message }}</header>\n  <close-button :on-close-callback=\"onClose\" class=\"newsletter__btn_error\">Luk</close-button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResponseErrorView.vue
// module id = 108
// module chunks = 0